import { createGlobalStyle, DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  colors: {
    actionInactive: 'hsl(300, 43%, 95%)',
    actionDefault: 'hsl(300, 50%, 45%)',
    actionHover: 'hsl(300, 50%, 35%)',
    actionActive: 'hsl(300, 50%, 25%)',
    statusError: 'hsl(0, 76%, 57%)',
    statusSuccess: 'hsl(132, 59%, 51%)',
    statusWarning: 'hsl(34, 100%, 64%)',
    typographyHeadersLight: 'hsl(0, 0%, 0%)',
    typographyHeadersDark: 'hsl(0, 0%, 100%)',
    typographyBodyLight: 'hsl(0, 0%, 40%)',
    typographyBodyDark: 'hsl(0, 0%, 90%)',
    backgroundDark: 'hsl(0, 0%, 0%)',
    backgroundDarkOverlay: 'hsla(0, 0%, 0%, 0.2)',
    backgroundLight: 'hsl(0, 0%, 100%)',
    backgroundAccent: 'hsl(0, 0%, 90%)',
    backgroundScroll: 'hsl(0, 0%, 95%)',
    brand: 'hsl(300, 50%, 45%)',
    brandAccent: 'hsl(300, 43%, 95%)',
    adminBorder: 'hsl(216, 12%, 84%)',
  },
  typography: {
    heading1: {
      fontWeight: '700',
      lineHeight: '133.333%',
      fontSize: '1.5rem',
    },
    title: {
      fontWeight: '700',
      lineHeight: '150%',
      fontSize: '1rem',
    },
    body: {
      fontWeight: '400',
      lineHeight: '150%',
      fontSize: '1rem',
    },
    label: {
      fontWeight: '700',
      lineHeight: '171.429%',
      fontSize: '0.9rem',
    },
  },
  dimensions: {
    headerHeight: '3.5rem',
    footerHeight: '4.625rem',
  },
};

// Spacers
export enum Spacer {
  DEFAULT = 1,
}

export enum Sizes {
  PROFILE_IMAGE = '3.5rem',
  LISTING_IMAGE = '12.5rem',
}

export enum Spacers {
  XS = Spacer.DEFAULT * 0.5,
  SM = Spacer.DEFAULT * 0.563,
  MD = Spacer.DEFAULT * 0.75,
  ML = Spacer.DEFAULT * 0.875,
  BASE = Spacer.DEFAULT * 1,
  LG = Spacer.DEFAULT * 1.5,
  XLG = Spacer.DEFAULT * 1.75,
  XL = Spacer.DEFAULT * 3,
  XXL = Spacer.DEFAULT * 3.25,
}

export const GlobalStyles = createGlobalStyle`
html,
body {
  width: 100vw;
  height: 100vh;
  font-family: var(--inter);
  color: hsl(210deg 15% 20%); /* Primary text color: dark muted navy */
  background-color: hsl(0, 0%, 100%); /* Light neutral background */
}
*, *::after, *::before {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
button {
  font-family: inherit;
  background: none;
}
a {
  color: inherit;
  text-decoration: none;
}
html:not(:has(.auth-page)) .Toastify__toast-container--top-right {
  margin: 4rem 0.5rem;
  padding: 0;
}
html:not(:has(.auth-page)) .Toastify__toast-container--bottom-center {
  padding-bottom: 6.125rem;
  width: calc(100% - 2rem);
  margin-left: 1rem;
  gap: ${Spacers.BASE}rem;
}
html:has(.auth-page) .Toastify__toast-container--bottom-center {
  width: calc(100% - 2rem);
  margin-left: 1rem;
  gap: ${Spacers.BASE}rem;
  margin-bottom: ${Spacers.LG}rem;
}
html:has(.auth-page) .Toastify__toast-container--top-right {
  margin: 0.5rem 0.5rem;
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
  html {
    font-synthesis: none;
  }
}
`;
